import {useEffect} from 'react';

import {
  SEGREGATION_TERMS,
  SEGREGATION_TOOLTIP,
  MAINTENANCE_SITE_CREDENCIAMENTO
} from '../constants/parameterization';
import {getParameterization} from '../services/Api';
import {useParameterizationStore} from '../store/slices/parameterizationStore';

export const useGetParameterization = (params) => {
  const setSegregationTerms = useParameterizationStore(
    (state) => state.setSegregationTerms
  );
  const setSegregationTooltip = useParameterizationStore(
    (state) => state.setSegregationTooltip
  );
  const setMaintenance = useParameterizationStore(
    (state) => state.setMaintenance
  );

  const updateParameterizations = (parameterizationReceived) => {
    const newValue = parameterizationReceived.value === 'true' ? true : false;

    switch (parameterizationReceived.key) {
      case SEGREGATION_TERMS:
        setSegregationTerms(newValue);
        break;

      case SEGREGATION_TOOLTIP:
        setSegregationTooltip(newValue);
        break;

      case MAINTENANCE_SITE_CREDENCIAMENTO:
        setMaintenance(newValue);
        break;
    }
  };

  useEffect(() => {
    getParameterization(params).then((response) => {
      updateParameterizations(response.data);
    });
  }, []);
};
